import { DatePicker } from '@panwds/react-ui';
import { format } from 'date-fns';
import React from 'react';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { BaseDateFilter } from './BaseDateFilter.esm.js';

const timeFormat = (time) => format(new Date(time), 'PPp');
const DateFilter = ({ initialDateFromFilter = (filterValue) => {
    const date = new Date(`${filterValue}`);
    if (date.toString() === 'Invalid Date')
        return;
    return date;
}, onCustomApply = (date) => {
    return date.toISOString();
}, customLabel = (date) => {
    return timeFormat(date);
}, customText, id = 'date-filter', ...rest }) => {
    const { filters } = useFilters();
    return (React.createElement(BaseDateFilter, { ...rest, customLabel: customLabel, customText: customText, Picker: React.createElement(DatePicker, { initialDate: initialDateFromFilter === null || initialDateFromFilter === void 0 ? void 0 : initialDateFromFilter(filters[rest.name]), onApply: onCustomApply }), id: id }));
};

export { DateFilter };
//# sourceMappingURL=DateFilter.esm.js.map
